import { Uuid } from '@lib/shared-interface-utility-types';

export type GetStudentAssignmentsByClassId = {
    studentId: Uuid;
    classId: Uuid;
};
